import { useState } from 'react';
import { Link } from 'react-router-dom';
import type { WritingTeaser } from '../lib/types';

type Props = { posts: WritingTeaser[] };

export function Writing({ posts }: Props) {
  return (
    <section
      id="section-writing"
      className="section"
      style={{ padding: '56px 28px' }}
    >
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'baseline',
          marginBottom: 24,
          flexWrap: 'wrap',
          gap: 8,
        }}
      >
        <div className="eyebrow">§ 04 · Writing · blog.danmerritts.com</div>
        <Link
          to="/essays"
          style={{
            fontSize: 10.5,
            textTransform: 'uppercase',
            letterSpacing: 1.5,
            borderBottom: '1px solid var(--ink)',
            paddingBottom: 2,
            textDecoration: 'none',
          }}
        >
          all posts →
        </Link>
      </div>
      <div>
        {posts.map((w) => (
          <WritingRow key={w.slug} post={w} />
        ))}
      </div>
    </section>
  );
}

function WritingRow({ post: w }: { post: WritingTeaser }) {
  const [hover, setHover] = useState(false);
  return (
    <Link
      to={`/essays/${w.slug}`}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      className="writing-row"
      style={{
        display: 'grid',
        gridTemplateColumns: '110px 1fr auto 60px',
        gap: 24,
        padding: '18px 0',
        borderTop: '1px solid var(--ink)',
        alignItems: 'baseline',
        cursor: 'pointer',
        textDecoration: 'none',
        color: 'inherit',
      }}
    >
      <div className="tabular" style={{ opacity: 0.6 }}>
        {w.date}
      </div>
      <div
        className="serif writing-title"
        style={{
          fontSize: 26,
          lineHeight: 1.15,
          letterSpacing: -0.3,
          fontStyle: hover ? 'italic' : 'normal',
          color: hover ? 'var(--accent)' : 'var(--ink)',
          transition: 'color 0.14s',
        }}
      >
        {w.title}
      </div>
      <div
        className="serif italic writing-kicker"
        style={{ fontSize: 15, opacity: 0.7 }}
      >
        {w.kicker}
      </div>
      <div style={{ textAlign: 'right', fontSize: 11, opacity: 0.6 }}>
        {w.minutes} min
      </div>
    </Link>
  );
}
